import { combineReducers } from 'redux';

import basket, { initialState as basketInitialState } from './basketReducer';
import products, { initialState as productsInitialState } from './productsReducer';
import pictures, { initialState as picturesInitialState } from './picturesReducer';
import common, { initialState as commonInitialState } from './commonReducer';

export const rootReducer = combineReducers({
  basket,
  products,
  pictures,
  common,
});

export const initialState = {
  basket: basketInitialState,
  products: productsInitialState,
  pictures: picturesInitialState,
  common: commonInitialState,
};
